import React from 'react';

class Dialog extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        $(this._modal).modal({
            backdrop: true,
            keyboard: true,
            show: false
        });
    }

    componentDidUpdate() {
        let onCloseDialog = this.props.events.onCloseDialog;
        let modal = this._modal;

        if (!this._wasRendered)
            return;

        $(modal).modal('show');
        // $(modal).on('shown.bs.modal', function () { $(modal).focus() });
        $(modal).on('hidden.bs.modal', onCloseDialog);
    }

    render() {
        let dialog = this.props.dialog;
        this._wasRendered = true;

        if (!dialog || !dialog.title || dialog.title.length === 0 || !dialog.message || dialog.message.length === 0) {
            this._wasRendered = false;
            return null;
        }

        return (
            <div className="dialog-modal">
                <div className="modal fade" tabIndex='-1' ref={(modal) => this._modal = modal}>
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                <h4 className="modal-title">{dialog.title}</h4>
                            </div>
                            <div className="modal-body" dangerouslySetInnerHTML={{ __html: dialog.message }}>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-default" data-dismiss="modal">Sair</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Dialog;


// WEBPACK FOOTER //
// src/views/controls/Dialog.jsx